import { render } from "./TheX.vue?vue&type=template&id=f73ce61a&scoped=true"
import script from "./TheX.vue?vue&type=script&lang=js"
export * from "./TheX.vue?vue&type=script&lang=js"

import "./TheX.vue?vue&type=style&index=0&id=f73ce61a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73ce61a"]])

export default __exports__